// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3D8DA","error":"Textarea_error__2-I3U","readonly":"Textarea_readonly__a_Jln","disabled":"Textarea_disabled__1hjlH"};